import React from 'react';
import './Topic.css';

const Topic = () => {
  return (
    <div className="topic">
      <div className="topic__item">
        <p>Arts & Crafts</p>
      </div>
      <div className="topic__item">
        <p>Business</p>
      </div>
      <div className="topic__item">
        <p>Design</p>
      </div>
      <div className="topic__item">
        <p>Education</p>
      </div>
      <div className="topic__item">
        <p>Entertainment</p>
      </div>
      <div className="topic__item">
        <p>
          Food <br /> & <br /> Beverages
        </p>
      </div>
      <div className="topic__item">
        <p>Government</p>
      </div>
      <div className="topic__item">
        <p>NGO&apos;s</p>
      </div>
      <div className="topic__item">
        <p>Oil & Gas</p>
      </div>
      <div className="topic__item">
        <p>Technology</p>
      </div>
    </div>
  );
};

export default Topic;
